import { API_URL } from '../../../app-config/constants';
import { get, post, remove } from '../request';

const BASE_URL = `${API_URL}/ai-observer`;

export interface CustomPrompt {
    id: string;
    companyId: string;
    type: string;
    prompt: string;
    createdBy: string;
    createdAt: string;
}

export interface CustomPromptType {
    type: string;
    defaultPrompt: string;
    featureType:
        | 'FEEDBACK_TO_OBJECTIVES'
        | 'FEEDBACK_SUMMARY'
        | 'OBJECTIVE_COACH'
        | 'REVIEW_CYCLE_SUMMARY'
        | 'REVIEW_QUESTION_LABELER'
        | 'WRITING_ASSISTANT'
        | 'COPILOT';
}

getCustomPromptTypes.operation = 'NO_OPERATION';
export function getCustomPromptTypes() {
    return get<CustomPromptType[]>(`${BASE_URL}/prompts/types`);
}

// returns a list for ladda caching (the list has zero or one items)
getCustomPromptForType.operation = 'READ';
export function getCustomPromptForType(args: { companyId: string; type: string }) {
    return get<CustomPrompt[]>(`${BASE_URL}/prompts/${args.companyId}/${args.type}`);
}

saveCustomPrompt.operation = 'CREATE';
saveCustomPrompt.invalidates = ['getCustomPromptForType'];
export function saveCustomPrompt(companyId: string, prompt: Pick<CustomPrompt, 'companyId' | 'type' | 'prompt'>) {
    return post<CustomPrompt>(`${BASE_URL}/prompts/${companyId}`, { postData: prompt });
}

deleteCustomPrompt.operation = 'NO_OPERATION';
deleteCustomPrompt.invalidates = ['getCustomPromptForType'];
export function deleteCustomPrompt(companyId: string, id: string) {
    return remove<CustomPrompt>(`${BASE_URL}/prompts/${companyId}/${id}`);
}

export interface GlobalAiCoachPromptDto {
    id?: string;
    prompt: string;
}

getAiCoachGlobalPrompt.operation = 'READ';
export async function getAiCoachGlobalPrompt() {
    const response = await get<GlobalAiCoachPromptDto>(`${BASE_URL}/prompts/coach/global`);
    return { ...response, id: 'global_copilot_prompt' };
}

saveAiCoachGlobalPrompt.operation = 'CREATE';
saveAiCoachGlobalPrompt.invalidates = ['getAiCoachGlobalPrompt'];
export async function saveAiCoachGlobalPrompt(prompt: string) {
    const response = await post<GlobalAiCoachPromptDto>(`${BASE_URL}/prompts/coach/global`, {
        postData: { prompt },
    });
    return { ...response, id: 'global_copilot_prompt' };
}
